import './ViewPostModal.css';

import React, { useEffect, useState } from 'react';
import { ConnectWithoutContact } from '@mui/icons-material';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import PayloadParserFactory from '../components/payload/PayloadParserFactory';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const ViewPostModal = ({ post = null, open, onClose }) => {
    const { t } = useB2BTranslation('b2b-social');

    const [currentPost, setCurrentPost] = useState(post);

    const handleClose = (event) => {
        onClose && onClose(event);
    }

    useEffect(() => {
        if (post && currentPost !== post) {
            setCurrentPost(post);
        }
    } , [post]);

    return (
        <B2BPopUpForm
            icon={<ConnectWithoutContact />}
            open={open}
            onClose={handleClose}
            title={t('View Post')}
            className={'view-post-modal'}
        >
            <PayloadParserFactory post={currentPost} />
        </B2BPopUpForm>
    );
}

export default ViewPostModal;